export default __webpack_public_path__ + "static/media/TL04.6d0ff09a.mp3";